<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Provider Charges

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body padding-top-0px">
        <div class="row border-top border-bottom margin-top-5px bk-color-light" *ngIf="SelectedService">
          <div class="col-md-4  text-align-left">
            <div><label class=" font-weight-bold label-color-consultant">Service Name</label></div>
            <div><label>{{SelectedService.Name}}</label></div>
          </div>
          <div class="col-md-4  text-align-left">
            <div><label class="label-color-consultant  font-weight-bold">Category</label></div>
            <div><label>{{SelectedService.ServiceCategory}}</label></div>
          </div>
          <div class="col-md-4 text-align-left">
            <div><label class=" font-weight-bold label-color-consultant">Base Price</label></div>
            <div><label>{{SelectedService.BasePrice}}</label></div>
          </div>
        </div>
       

        <ul class="nav nav-tabs nav-tab-service margin-top-13px" id="tabContent">
          <li class="active margin-right-30px" ><a class="nav-item2 active" href="#details" data-toggle="tab">List</a></li>
          <li><a class="nav-item2" href="#access-security" data-toggle="tab">Add/Edit</a></li>
        
        </ul>

        <div class="tab-content">
          <div class="tab-pane active" id="details">
            <div class="card">
              <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                <div class="table-component">
                  <div class="table-responsive overflow-x">


                    <table class="table table-striped margin-left-zero">

                      <thead class="">
                        <tr>

                          <th class="">Branch</th>

                          <th class="">Consultant</th>

                          <th class="">C Factor</th>

                          <th class="text-align-right">C %</th>
                          <th class="">Provider Cost</th>
                          <th class="text-align-right">Commission</th>


                          <!--<th class=""></th>-->




                        </tr>
                      </thead>

                      <tbody class="table-body">
                        <!--{{ConsultantMapData.length}}-->
                        <tr *ngFor="let l of ConsultantMapData">


                          <td class=" td-padding "> {{l.BranchShortName}}</td>
                          <td class=" td-padding text-align-left"> {{l.DisplayName}}</td>

                          <td class=" td-padding text-align-center">{{l.CommissionFactor}}</td>

                          <td class=" td-padding text-align-right">{{l.CommissionPercentage}}</td>
                          <td class=" td-padding text-align-center">{{l.ChargeAmount}}</td>

                          <td class=" td-padding text-align-right">{{l.CommissionAmount}}</td>


                          <!--<td class=" td-padding text-align-center">
      <button type="button" (click)="edit_()"
              class="btn  actions-btn-prime2 benfits-button font-size margin-left-zero border-color " title="Edit">

        <i class="fas fa-pencil-alt color-edit-icon"></i>
      </button>
    </td>-->




                        </tr>
                      </tbody>

                    </table>
                  </div>
                </div>
              </div>
              <!--<div class="card-footer text-align-center">
                <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
              </div>-->
            </div>
          
          </div>

          <div class="tab-pane" id="access-security">
            <div class="row">

              <div class="col-md-3  padding-right-0px border-right">
                <div class="card">
                  <div class="card-header wh-header header3 padding-left-0px font-size-14 padding-bottom-4px">
                    Select Provider

                  </div>
                  <div class="card-body padding-top-0px margin-left-zero padding-left-0px">
                    <div class="row  padding-top-10px padding-bottom-10px margin-right-0px">
                      <div class="col-md-12 padding-right-0px">
                        <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                      </div>


                    </div>
                    <div class="chatsd product-chart-wrapper product-chat-width-92 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                      <div class="row border-bottom rowfor margin-top-11 margin-left-zero nav-link-hand margin-right-0px"(click)="viewprovider(l)" *ngFor="let l of pdata">
                        <a  class=" margin-left-6px">{{l.DisplayName}}</a>
                      </div>
                      </div>
                    </div>
                  </div>
              </div>



              <div class="col-md-9" *ngIf="ShowService">

                <div class="row">
                  <div class="col-md-12 padding-left-2px padding-right-0px">
                    <div class="card">

                      <div class="card-body margin-left-zero padding-left-8px padding-right-0px padding-top-8px padding-bottom-0px">
                        <div class="row" *ngIf="SelectedProvider">
                          <!--<div class="col-md-3 text-align-right color"><label class="font-color-secondary">Provider Name</label></div>:-->
                          <div class="col-md-7 text-align-left">
                            <img class="img-circle width-service-25" src="Ashley.jpg" />
                            <label class="font-size-14 margin-left-5px">{{SelectedProvider.DisplayName}}</label>
                          </div>
                        </div>
                        <div class="table-component">
                          <div class="table-responsive">


                            <table class="table table-striped margin-left-zero">

                              <thead class="">
                                <tr>
                                  <th class="min-width-0px"></th>

                                 <th>Branch</th>
                                  <th>Branch Price</th>
                                  <th>Consultant Price</th>
                                  <th>Commission</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody class="table-body">
                                
                                <tr *ngFor="let l of SelectedConsultantMapData">
                                  <td class="td-padding ">

                                    <input type="checkbox" 
                                    name="l.IsSelected"
                                           [(ngModel)]="l.IsSelected"
                                   />
                                    <i class="input-helper"></i>

                                  </td>

                                  <td class="text-align-center">
                                    {{l.BranchShortName}}
                                  </td>
                                  <td class="text-align-right">
                                    <label>{{l.BranchBasePrice}}</label>
                                  </td>
                                  <td class="td-padding ">

                                    <input type="number" class="form-control" [(ngModel)]="l.ChargeAmount"
                                             
                                           min="1" max="10" />
                                    
                                  </td>
                                  <td class="td-padding " >
                                    <input type="number" class="form-control" [(ngModel)]="l.CommissionAmount"
                                              
                                           min="1" max="10" />
                                  </td>

                                  <td class="text-align-right">
                                    <button type="submit" (click)="onSubmit(l)"   class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="l?.IsSelected"><i class="far fa-save"></i></button>
                                    <button (click)="OnDelete(l)" class="button-service-save font-size-16px color-Rejected  nav-link-hand" title="Delete" *ngIf="l?.IsSelected && l.ConsultantServiceCode>0 "><i class="far fa-trash-alt"></i></button>

                                  </td>



                                </tr>
                                <!--<tr>
                                  <td class="td-padding ">

                                    <input type="checkbox" />

                                    <i class="input-helper"></i>

                                  </td>

                                  <td class="text-align-center">
                                    B1
                                  </td>
                                  <td class="text-align-right">
                                    <label>200</label>
                                  </td>
                                  <td class="td-padding ">
                                    <input type="number" class="form-control" [(ngModel)]="RequestedPositions"
                                           readonly
                                           min="1" max="10" />
                                  </td>
                                  <td class="td-padding ">
                                    <input type="number" class="form-control" [(ngModel)]="RequestedPositions"
                                           readonly
                                           min="1" max="10" />
                                  </td>

                                  <td class="text-align-right">
                                    <a (click)="del_(l.ActorDocPageCode)" class="font-size-16px color-secondary nav-link-hand" title="Save"><i class="far fa-save"></i></a>
                                    <a (click)="del_(l.ActorDocPageCode)" class="font-size-16px color-Rejected margin-left-17px nav-link-hand" title="Remove"><i class="far fa-trash-alt"></i></a>

                                  </td>



                                </tr>-->
                              </tbody>

                            </table>

                          </div>
                        </div>
                       
                        
                      </div>
                      <!--<div class=" card-footer text-align-center">
                        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Cancel</button>
                        <button type="submit" *ngIf='!isRequesting' (click)="gotoservice()" class="btn actions-btn-prime margin-right-auto">Save</button>
                      </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

         
        </div>

        

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
      </div>
  </div>
</div>
  </div>
